import { useCallback, useEffect } from 'react';
import { useDispatchApp } from './useAppDispatch';
import { useAppSelector } from './useAppSelector';
import { getPersonalDetails } from 'API/personalDetails';
import { setPersonalDetails } from 'Store/PersonalDetailsSlice';
import { getIsLawyer, getIsLawyerAndUser } from 'Utils/lawyers';
import { useIsLawyerArea } from './useIsLawyerArea';

export const usePersonalDetails = () => {
  const dispatch = useDispatchApp();
  const personalDetails = useAppSelector(
    ({ personalDetails: { personalDetails } }) => personalDetails,
  );

  const imposterId = useAppSelector(
    ({ imposter: { imposterId } }) => imposterId,
  );

  const isLawyerArea = useIsLawyerArea();

  const initializePersonalDetails = useCallback(async () => {
    const result = await getPersonalDetails();
    if (result) {
      dispatch(setPersonalDetails(result));
    }
  }, [dispatch]);

  useEffect(() => {
    if (getIsLawyerAndUser() ? !isLawyerArea : !getIsLawyer())
      initializePersonalDetails();
  }, [initializePersonalDetails, imposterId, isLawyerArea]);

  return personalDetails;
};
